if (!customElements.get('wlsn-buybox-frequency-selector')) {
  class WLSNBuyboxFrequencySelector extends HTMLElement {
    constructor() {
      super();
      this.boundHandleCardClick = this._handleCardClick.bind(this);
      this.boundHandleCardKeydown = this._handleCardKeydown.bind(this);
      this.boundHandleVariantChange = this._handleVariantChange.bind(this);
    }

    get elements() {
      const form = this.closest('wlsn-product-form');
      return {
        purchaseTypeInput: this.querySelector('input[name="purchase-type"]'),
        sellingPlanInput: this.querySelector('input[name="selling_plan"]'),
        variantIdInput: form ? form.querySelector('input[name="id"]') : null,
        groups: Array.from(this.querySelectorAll('.js-frequency-variant-group')),
        cards: Array.from(this.querySelectorAll('.js-frequency-card')),
      };
    }

    connectedCallback() {
      const { cards, variantIdInput } = this.elements;

      cards.forEach((card) => {
        card.addEventListener('click', this.boundHandleCardClick);
        card.addEventListener('keydown', this.boundHandleCardKeydown);
      });

      if (variantIdInput) {
        variantIdInput.addEventListener('change', this.boundHandleVariantChange);
      }
    }

    disconnectedCallback() {
      const { cards, variantIdInput } = this.elements;

      cards.forEach((card) => {
        card.removeEventListener('click', this.boundHandleCardClick);
        card.removeEventListener('keydown', this.boundHandleCardKeydown);
      });

      if (variantIdInput) {
        variantIdInput.removeEventListener('change', this.boundHandleVariantChange);
      }
    }

    /* ── Card interaction ── */

    _handleCardClick(e) {
      this._selectCard(e.currentTarget);
    }

    _handleCardKeydown(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this._selectCard(e.currentTarget);
      }
    }

    _selectCard(card) {
      const { groups, cards } = this.elements;
      const group = groups.find((group) => group.contains(card));
      if (!group) return;

      // Toggle active within this group's cards only
      cards.forEach((c) => {
        c.classList.toggle('active', c === card);
      });

      this._updateInputs(card.dataset.purchaseType, group.dataset.sellingPlanId);
    }

    /* ── Variant change (fired by quantity selector updating input[name="id"]) ── */

    _handleVariantChange() {
      const { variantIdInput, purchaseTypeInput, groups, cards } = this.elements;
      const newVariantId = variantIdInput?.value;
      if (!newVariantId) return;

      let activeGroup = null;

      groups.forEach((group) => {
        if (group.dataset.variantId === newVariantId) {
          group.removeAttribute('hidden');
          activeGroup = group;
        } else {
          group.setAttribute('hidden', '');
        }
      });

      if (!activeGroup) return;

      // Restore the current purchase-type selection in the newly visible group
      const purchaseType = purchaseTypeInput?.value || 'subscription';
      cards.forEach((card) => {
        card.classList.toggle('active', card.dataset.purchaseType === purchaseType);
      });

      // Update selling_plan to match new variant (or clear for OTP)
      this._updateInputs(purchaseType, activeGroup.dataset.sellingPlanId);
    }

    /* ── Input sync ── */

    _updateInputs(purchaseType, sellingPlanId) {
      const { purchaseTypeInput, sellingPlanInput } = this.elements;

      if (purchaseTypeInput) {
        purchaseTypeInput.value = purchaseType;
        purchaseTypeInput.dispatchEvent(new Event('input', { bubbles: true }));
        purchaseTypeInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (sellingPlanInput) {
        sellingPlanInput.value = purchaseType === 'subscription' ? (sellingPlanId || '') : '';
        sellingPlanInput.dispatchEvent(new Event('input', { bubbles: true }));
        sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  customElements.define('wlsn-buybox-frequency-selector', WLSNBuyboxFrequencySelector);
}
